/**
 * Return True if str is a number
 * @param str {String}
 */
export default function isNumber(str) {
  return /^\d+$/.test(str);
}
